module.exports = __webpack_public_path__ + "img/corcoran-logo.5fdc0df2.png";